import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import { IconButton } from '@material-ui/core';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import grey from '@material-ui/core//colors/grey';

const useStyles = makeStyles((theme) => ({
  card: {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: theme.palette.backdrop.main,
    height: '100%',
  },
  content: {
    padding: 0,
    paddingLeft: theme.spacing(1),
  },
  header: {
    padding: theme.spacing(1),
    color: grey[700],
  },
  action: {
    alignSelf: 'center',
  },
  metric: {
    color: theme.palette.primary.main,
    fontWeight: 'bold',
  },
}));

const Gadget = ({ gridSize, metric, attributes, disabled }) => {
  const classes = useStyles();

  return (
    <Grid item xs={gridSize}>
      <Card className={classes.card}>
        <CardHeader
          className={classes.header}
          classes={{ action: classes.action }}
          action={
            !disabled && (
              <IconButton aria-label="settings">
                <MoreVertIcon />
              </IconButton>
            )
          }
          titleTypographyProps={{ variant: 'subtitle2' }}
          title={attributes.label}
        />

        <CardContent className={classes.content}>
          <Typography className={classes.metric} variant="h6" component="div">
            {attributes.formatter(metric)}
          </Typography>
        </CardContent>
      </Card>
    </Grid>
  );
};

Gadget.defaultProps = {
  gridSize: 4,
  disabled: true,
  metric: Number.NaN,
};

Gadget.propTypes = {
  gridSize: PropTypes.number,
  metric: PropTypes.any,
  attributes: PropTypes.object.isRequired,
  disabled: PropTypes.bool,
};

export default Gadget;
